<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                    {{ $t("tarifMasteEdit") }}
                  </h6>
                  <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <form class="forms-sample" @submit.prevent="submitData" method="PATCH">

                    <div class="row mb-3">
                      <!-- kolom kiri -->
                      <div class="col-lg-7">

                        <!-- Tariff Master Wms -->
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="tarifMasterId" class="col-form-label" style="padding-left: 25px">{{
                              $t("tarifMasterId") }}</label>
                          </div>
                          <div class="col-lg-8">
                            <input type="text" class="form-control" id="tarifMasterId"
                              :placeholder="$t('tarifMasterId')" v-model="forms.tarifMasterId" required disabled />
                          </div>
                        </div>
                        <!-- Customer ID -->
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="customerId" class="col-form-label" style="padding-left: 25px">{{
                              $t("customerId")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <v-select @input="loadCustomerId" :options="fetchCustomer" v-model="forms.customerId"
                              label="customerId" @search="asyncSearchCustomer" return-object>
                              <template slot="option" slot-scope="option">
                                {{ option.customerId }} - {{ option.customerName }}
                              </template>
                            </v-select>
                            <div v-if="errors.customerId">
                              <div v-for="error in errors.customerId" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Query -->
                        <div class="row mb-3">
                          <div class="col-lg-4">
                            <label for="query" class="col-form-label" style="padding-left: 25px">{{ $t("query")
                              }}</label>
                          </div>
                          <div class="col-lg-8">
                            <textarea class="form-control" id="query" :placeholder="$t('query')"
                              v-model="forms.queryRateHeader" rows="10" max-rows="20"></textarea>
                            <div v-if="errors.queryRateHeader">
                              <div v-for="error in errors.queryRateHeader" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Query Storage Beginning Balance -->
                        <div class="row mb-3" v-show="forms.beginningBalanceFlag == 'Y'">
                          <div class="col-lg-4">
                            <label for="queryBeginningBalance" class="col-form-label" style="padding-left: 25px">{{
                              $t("queryBeginningBalance")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <textarea class="form-control" id="queryBeginningBalance"
                              :placeholder="$t('queryBeginningBalance')" v-model="forms.queryBeginningBalance" rows="10"
                              max-rows="20"></textarea>
                            <div v-if="errors.queryBeginningBalance">
                              <div v-for="error in errors.queryBeginningBalance" :key="error"
                                class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Query Rental Pallet Beginning Balance -->
                        <div class="row mb-3" v-show="forms.begBalRentPallFlag == 'Y'">
                          <div class="col-lg-4">
                            <label for="queryBegBalRentPall" class="col-form-label" style="padding-left: 25px">{{
                              $t("queryBegBalRentPall")
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <textarea class="form-control" id="queryBegBalRentPall"
                              :placeholder="$t('queryBegBalRentPall')" v-model="forms.queryBegBalRentPall" rows="10"
                              max-rows="20"></textarea>
                            <div v-if="errors.queryBegBalRentPall">
                              <div v-for="error in errors.queryBegBalRentPall" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>


                      <!-- kolom kanan -->
                      <div class="col-lg-5">

                        <div class="row mb-3">
                          <div class="col-lg-5">
                            <label for="status" class="col-form-label" style="padding-left: 75px">{{
                              $t("statusTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-7">
                            <!-- Radio Buttons for Status -->
                            <div class="row mt-2" style="width:220px">
                              <div class="col" v-for="statusOption in fetchStatus" :key="statusOption"
                                style="display: flex; align-items: center;">
                                <label>
                                  <input type="radio" v-model="forms.status" :value="statusOption"
                                    :id="'status-' + statusOption" style="margin-right: 5px;" />
                                  {{ statusOption }}
                                </label>
                              </div>
                            </div>
                            <!-- Error handling for status -->
                            <div v-if="errors.status">
                              <div v-for="error in errors.status" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-5">
                            <label for="weeklyTransmitFlag" class="col-form-label" style="padding-left: 75px">{{
                              $t("weeklyTransmitFlag")
                            }}</label>
                          </div>
                          <div class="col-lg-7">
                            <!-- Radio Buttons for Weekly Transmit Flag -->
                            <div class="row mt-2" style="width:220px">
                              <div class="col" v-for="flagOption in fetchYesNo" :key="flagOption"
                                style="display: flex; align-items: center;">
                                <label>
                                  <input type="radio" v-model="forms.weeklyTransmitFlag" :value="flagOption"
                                    :id="'weeklyTransmitFlag-' + flagOption" style="margin-right: 5px;" />
                                  {{ flagOption === 'Y' ? $t('Yes') : $t('No') }}
                                </label>
                              </div>
                            </div>
                            <!-- Error handling for weeklyTransmitFlag -->
                            <div v-if="errors.weeklyTransmitFlag">
                              <div v-for="error in errors.weeklyTransmitFlag" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-5">
                            <label for="multiWhFlag" class="col-form-label" style="padding-left: 75px">{{
                              $t("multi_warehouse_flag")
                            }}</label>
                          </div>
                          <div class="col-lg-7">
                            <!-- Radio Buttons for Multi Warehouse Flag -->
                            <div class="row mt-2" style="width:220px">
                              <div class="col" v-for="flagOption in fetchYesNo" :key="flagOption"
                                style="display: flex; align-items: center;">
                                <label>
                                  <input type="radio" v-model="forms.multiWhFlag" :value="flagOption"
                                    :id="'multiWhFlag-' + flagOption" style="margin-right: 5px;" />
                                  {{ flagOption === 'Y' ? $t('Yes') : $t('No') }}
                                </label>
                              </div>
                            </div>
                            <!-- Error handling for multiWhFlag -->
                            <div v-if="errors.multiWhFlag">
                              <div v-for="error in errors.multiWhFlag" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-5">
                            <label for="beginningBalanceFlag" class="col-form-label" style="padding-left: 75px">{{
                              $t("beginningBalanceFlag")
                            }}</label>
                          </div>
                          <div class="col-lg-7">
                            <!-- Radio Buttons for Beginning Balance Flag -->
                            <div class="row mt-2" style="width:220px">
                              <div class="col" v-for="flagOption in fetchYesNo" :key="flagOption"
                                style="display: flex; align-items: center;">
                                <label>
                                  <input type="radio" v-model="forms.beginningBalanceFlag" :value="flagOption"
                                    :id="'beginningBalanceFlag-' + flagOption" style="margin-right: 5px;" />
                                  {{ flagOption === 'Y' ? $t('Yes') : $t('No') }}
                                </label>
                              </div>
                            </div>
                            <!-- Error handling for beginningBalanceFlag -->
                            <div v-if="errors.beginningBalanceFlag">
                              <div v-for="error in errors.beginningBalanceFlag" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-lg-5">
                            <label for="begBalRentPallFlag" class="col-form-label" style="padding-left: 75px">{{
                              $t("begBalRentPallFlag")
                            }}</label>
                          </div>
                          <div class="col-lg-7">
                            <!-- Radio Buttons for Beg Bal Rent Pall Flag -->
                            <div class="row mt-2" style="width:220px">
                              <div class="col" v-for="flagOption in fetchYesNo" :key="flagOption"
                                style="display: flex; align-items: center;">
                                <label>
                                  <input type="radio" v-model="forms.begBalRentPallFlag" :value="flagOption"
                                    :id="'begBalRentPallFlag-' + flagOption" style="margin-right: 5px;" />
                                  {{ flagOption === 'Y' ? $t('Yes') : $t('No') }}
                                </label>
                              </div>
                            </div>
                            <!-- Error handling for begBalRentPallFlag -->
                            <div v-if="errors.begBalRentPallFlag">
                              <div v-for="error in errors.begBalRentPallFlag" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="card-footer">
                      <button class="btn btn-warning text-black fw-bolder btn-icon-text" @click="backForm"
                        type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "CmlTarifEdit",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      company_type: "",
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      company_group: "",
      fetchStatus: ["ACTIVE", "DEACTIVE"],
      fetchYesNo: ["Y", "N"],
      fetchCustomer: [],
      fetchFulfillment: [],
      customer: "",
      fulfillment: "",
      forms: {
        idTarifMasterHeader: "",
        tarifMasterId: "",
        customerId: "",
        status: "",
        queryRateHeader: "",
        addwho: "",
        editwho: "",
        adddate: "",
        editdate: "",
        multiWhFlag: "",
        beginningBalanceFlag: "",
        queryBeginningBalance: "",
        weeklyTransmitFlag: "",
        begBalRentPallFlag: "",
        queryBegBalRentPall: "",
      },
      userData: "",
      userRole: "",
    };
  },
  watch: {},
  methods: {
    loadCustomerId(value) {
      this.forms.customerId = value.customerId;
    },

    asyncSearchFulfillment() {
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/warehouse/get-data?download=all";

      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.fetchFulfillment = response.data.datas;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },

    asyncSearchCustomer() {
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/customer/get-data?download=all";

      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    resetForm() {
      this.customer = "";
      this.forms.tarifMasterId = "";
      this.forms.queryRateHeader = "";
      this.forms.queryBeginningBalance = "";
      this.forms.queryBegBalRentPall = "";
      this.forms.multiWhFlag = "N";
      this.forms.beginningBalanceFlag = "N";
      this.forms.weeklyTransmitFlag = "N";
      this.forms.begBalRentPallFlag = "N";
    },

    backForm() {
      window.location.href = "/billing-cml/master-tarif";
    },

    loadData(id) {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-tarif-master-cml/detail/" +
        id;
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          this.forms = response.data.datas;
          this.customer = { customerId: this.forms.customerId };
          this.fulfillment = response.data.datas.fulfillment;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.userData = userDatas.sub;
      this.userRole = userDatas.sub.role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission.controller == "BmTarifMasterHeaderController"
        ) {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_update) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
      this.asyncSearchFulfillment();
      this.asyncSearchCustomer();
    },

    submitData() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-tarif-master-cml/update/" +
        this.forms.idTarifMasterHeader;
      this.$http
        .patch(baseURI, this.forms, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.errors = [];
            this.success(response.data.datas.messages);

            var params = this.$onRandom(this.forms.idTarifMasterHeader);
            window.location.href =
              "/billing-cml/master-tarif/detail/" +
              params +
              "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.isLoading = true;
          //this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 401) {
              this.logout();
            } else if (error.response.status === 403) {
              this.$router.push("/authorized-error");
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () { },
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped></style>
